// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__141Z5","badges":"styles_badges__2HITj"};